module.exports = __webpack_public_path__ + "static/media/1ManagedServices.17107864.svg";